/** Dust motes as additive GL points. Attribute: (x css px, y css px, size css px, alpha). */
export const PARTICLE_VERT = /* glsl */ `#version 300 es
precision highp float;
layout(location = 0) in vec4 aP;
uniform vec2 uCanvasCss;
uniform float uDpr;
out float vAlpha;
void main() {
  vec2 ndc = vec2(aP.x / uCanvasCss.x * 2.0 - 1.0, 1.0 - aP.y / uCanvasCss.y * 2.0);
  gl_Position = vec4(ndc, 0.0, 1.0);
  gl_PointSize = max(1.0, aP.z * uDpr);
  vAlpha = aP.w;
}
`;

export const PARTICLE_FRAG = /* glsl */ `#version 300 es
precision mediump float;
in float vAlpha;
out vec4 outColor;
uniform vec3 uColor;
void main() {
  vec2 q = gl_PointCoord - 0.5;
  float d = length(q) * 2.0;
  float a = (1.0 - smoothstep(0.15, 1.0, d)) * vAlpha;
  outColor = vec4(uColor * a, a);
}
`;
